"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.twolinerSizeVariant = exports.onelinerSizeVariant = exports.itemLayoutSizeVariant = exports.itemTheme = void 0;
const component_theme_1 = require("@clds/component-theme");
const supportedSize = (size) => size;
exports.itemTheme = (0, component_theme_1.createTheme)({
    layout: {
        normal: {
            sizeVariant: {
                sm: {
                    slotSize: 'md',
                    horizontalMargin: component_theme_1.globalTheme.spacing.sm,
                    slotVerticalMargin: component_theme_1.globalTheme.spacing.xs,
                },
                md: {
                    slotSize: 'md',
                    horizontalMargin: component_theme_1.globalTheme.spacing.sm,
                    slotVerticalMargin: component_theme_1.globalTheme.spacing.sm,
                },
                lg: {
                    slotSize: 'lg',
                    horizontalMargin: component_theme_1.globalTheme.spacing.sm,
                    slotVerticalMargin: component_theme_1.globalTheme.spacing.md,
                },
            },
            oneliner: {
                sm: {
                    verticalMargin: component_theme_1.globalTheme.spacing.xs,
                    typographySize: supportedSize('xs'),
                },
                md: {
                    verticalMargin: component_theme_1.globalTheme.spacing.sm,
                    typographySize: supportedSize('sm'),
                },
                lg: {
                    verticalMargin: component_theme_1.globalTheme.spacing.md,
                    typographySize: supportedSize('md'),
                },
            },
            twoliner: {
                sm: {
                    gap: '0',
                    verticalMargin: component_theme_1.globalTheme.spacing.xxs,
                    typographySize: {
                        line1: supportedSize('xxs'),
                        line2: supportedSize('xxs'),
                    },
                },
                md: {
                    gap: '0.125rem',
                    verticalMargin: component_theme_1.globalTheme.spacing.xxs,
                    typographySize: {
                        line1: supportedSize('xs'),
                        line2: supportedSize('xxs'),
                    },
                },
                lg: {
                    gap: component_theme_1.globalTheme.spacing.xxs,
                    verticalMargin: component_theme_1.globalTheme.spacing.xs,
                    typographySize: {
                        line1: supportedSize('sm'),
                        line2: supportedSize('xxs'),
                    },
                },
            },
        },
    },
}, 'item');
const normalTheme = exports.itemTheme.layout.normal;
exports.itemLayoutSizeVariant = (0, component_theme_1.createVariant)((props) => normalTheme.sizeVariant[props.size]);
exports.onelinerSizeVariant = (0, component_theme_1.createVariant)((props) => normalTheme.oneliner[props.size]);
exports.twolinerSizeVariant = (0, component_theme_1.createVariant)((props) => normalTheme.twoliner[props.size]);
//# sourceMappingURL=theme.js.map